export const UPDATE_PASSWORD_FAILURE = 'Auth/UPDATE_PASSWORD_FAILURE';
export const UPDATE_PASSWORD_SUCCEEDED = 'Auth/UPDATE_PASSWORD_SUCCEEDED';
export const WRONG_CURRENT_PASSWORD = 'Auth/WRONG_CURRENT_PASSWORD';
export const CLEAR_STATE = 'Auth/CLEAR_STATE';
